import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'components/UIElements'
import STRINGS from 'utils/strings'
import { QUESTION_TYPE_MAP } from 'utils/constants'
import useFoodDiaryFeature from 'utils/hooks/useFoodDiaryFeature'
import './InReviewPanel.scss'

const InReviewPanel = ({ inReviewChecked, onToggleInReviewChecked, study, userId, questionType }) => {
  const { hasFoodDiary } = useFoodDiaryFeature({ study, userId })
  const isTimedMatchingGrid = questionType === QUESTION_TYPE_MAP.timedMatchingGrid

  if (!hasFoodDiary && !isTimedMatchingGrid) {
    return null
  }

  // Timed Matching Grid forces in_review off (not shown on participant review).
  if (isTimedMatchingGrid) {
    return (
      <div className='in-review attribute panel tmg-in-review'>
        <h5 className='label-small med-font'>{STRINGS.inReviewScreen}</h5>
        <Checkbox
          checked={false}
          disabled
          onClick={() => {}}
          label={STRINGS.inReviewDescription}
          toggle
        />
      </div>
    )
  }

  return (
    <div className='in-review attribute panel'>
      <h5 className='label-small med-font'>{STRINGS.inReviewScreen}</h5>
      <Checkbox
        checked={inReviewChecked}
        onClick={onToggleInReviewChecked}
        label={STRINGS.inReviewDescription}
        toggle
      />
    </div>
  )
}

InReviewPanel.propTypes = {
  inReviewChecked: PropTypes.bool,
  onToggleInReviewChecked: PropTypes.func,
  questionType: PropTypes.string,
  study: PropTypes.shape({}),
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default InReviewPanel
